<template>
  <LKRoadmapsFeedModalContainer
    content-class="modal--names w-form"
    @close="close"
  >
    <form class="names__content" @submit.prevent>
      <div class="names__header">
        <div class="text-lg-bold">
          Выберите направление
        </div>

        <IconClose
          @click.native="close"
        />
      </div>

      <div class="names__radio-groups LKRoadmapsFeedModalNames__groups">
        <label
          v-for="item in data"
          :key="item.id"
          class="names__radio-box w-radio LKRoadmapsFeedModalNames__label"
          @click="selected = item"
        >
          <div
            :class="{ 'w--redirected-checked': selected === item }"
            class="w-form-formradioinput w-form-formradioinput--inputType-custom names__radio w-radio-input"
          />
          <input type="radio" name="radio" style="display: none;">
          <span class="text-sm w-form-label">
            {{ item.name }}
          </span>
        </label>

        <ProgressCircular
          v-if="isLoadingData"
          :size="50"
          overlay
        />

        <div
          v-else-if="!data.length"
          class="text-md"
          v-text="'Список направлений пуст'"
        />
      </div>

      <div class="names__button">
        <input
          type="submit"
          :value="isLoading ? 'Подождите...' : 'Подтвердить'"
          :disabled="!selected"
          class="name__button w-button LKRoadmapsFeedModalNames__button"
          @click="onSubmit"
        >
      </div>
    </form>

    <div
      v-if="errorMessage"
      class="w-form-fail LKRoadmapsFeedModalNames__message"
      v-text="errorMessage"
    />
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import { RoadmapDirectionsFeedApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'

import ProgressCircular from '@/components/lk/LKProgressCircular.vue'
import IconClose from '@/components/lk/icons/LKIconClose.vue'
import LKRoadmapsFeedModalContainer from './LKRoadmapsFeedModalContainer.vue'


export default {
  name: 'LKRoadmapsFeedModalNames',
  components: {
    ProgressCircular,
    IconClose,
    LKRoadmapsFeedModalContainer,
  },
  props: {
    options: {
      type: Object,
    },
  },
  data: () => ({
    data: [],
    isLoading: false,
    isLoadingData: false,
    errorMessage: null,
    selected: null,
  }),
  created() {
    this.getDirections()
  },
  methods: {
    close(flag = false) {
      this.$emit('close', flag)
    },
    async getDirections() {
      this.isLoadingData = true

      const api = new RoadmapDirectionsFeedApi()

      const params = {
        roadmap_id: this.options.roadmap_id,
        school_id: this.options.school_id,
      }

      try {
        const { data } = await api.getAll(params)
        this.data = data
      } catch (e) {
        this.$notice.errors(e)
        this.errorMessage = getErrorMessages(e)?.[0] || 'Some thing wrong'
      }

      this.isLoadingData = false
    },
    async onSubmit() {
      this.isLoading = true

      const api = new RoadmapDirectionsFeedApi()
      const params = {
        roadmap_direction_id: this.selected.id,
        school_id: this.options.school_id,
      }

      try {
        const { data } = await api.create(params)
        const newNode = {
          // TODO: надо подумать че с этим делать, вероятно с бэка возвращать всё и сразу
          attention_count: 0,
          done_count: 0,
          events_unread_count: 0,
          expired_count: 0,
          in_progress_count: 0,
          needs_work_count: 0,

          is_confirmed: false,
          is_required: false,

          events: [],

          name: this.selected.name,
          ...data,

        }

        const existed = this.options.node.children.map((child) => child.data)

        this.options.node.setChildren([...existed, newNode])
        this.close(true)
      } catch (e) {
        this.errorMessage = getErrorMessages(e)?.[0] || 'Some thing wrong'
      }

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">

.LKRoadmapsFeedModalNames {
  &__button[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }

  &__groups {
    position: relative;
    height: 245px;
    max-height: 245px;
    padding-bottom: 0 !important;
  }

  &__label:last-child {
    margin-bottom: 0;
  }

  &__message {
    display: block !important;
  }
}
</style>
